/* eslint-disable @typescript-eslint/no-explicit-any */
import { ItemWithLabel } from '@innovyze/stylovyze/lib/components/Items';
import { FormControl } from '@mui/material';
import { FORM_MODES } from '@innovyze/stylovyze/lib/utils/constants';
import { useField } from 'formik';
import React from 'react';
import { useMode } from './contexts/StylovyzeFormContext';
import useGetCombinedAttributes from './hooks/useGetCombinedAttributes';
import useGetCombinedEvents from './hooks/useGetCombinedEvents';
import { DateTimeInput, DateTimeInputMode, useCompanyDateTime, } from '../DateTimeInput';
export default function InputDateTime(props) {
    const { fieldAttrs, dateTime, dataCy, networkError, keepLocalTime, dateTimeSeparator, invalidDateTimeString, } = props;
    const mode = useMode();
    const [field] = useField(fieldAttrs);
    const combinedEvents = useGetCombinedEvents({
        fieldAttrs,
        onDebounceChange: props.onDebounceChange,
        networkError,
        onFocus: dateTime.onFocus,
        onBlur: dateTime.onBlur,
        onChange: undefined,
    });
    const { formatDate } = useCompanyDateTime();
    const combinedAttributes = useGetCombinedAttributes({
        networkError,
        error: dateTime.error,
        helperText: dateTime.helperText,
    });
    const formatValidDate = () => {
        const format = formatDate({
            date: (field.value || ''),
            format: 
            // Translate the mode :(
            dateTime.mode === DateTimeInputMode.DATE_TIME
                ? 'date-time'
                : dateTime.mode === DateTimeInputMode.DATE
                    ? 'date'
                    : 'time',
            dateTimeSeparator: dateTimeSeparator ?? ' - ',
            zoneOptions: {
                keepLocalTime: keepLocalTime ?? true,
            },
        });
        return format !== 'Invalid DateTime' ? format : invalidDateTimeString;
    };
    return (React.createElement(FormControl, { variant: "standard", fullWidth: true }, mode === FORM_MODES.VIEW ? (React.createElement(ItemWithLabel, { label: dateTime.label, value: formatValidDate() })) : (React.createElement(DateTimeInput, { variant: dateTime.variant || 'outlined', margin: dateTime.margin || 'normal', color: dateTime.color || 'primary', "data-cy": dataCy, ...dateTime, ...combinedEvents, ...combinedAttributes, onChange: dateTime.onChange, dateTimeSeparator: dateTimeSeparator }))));
}
